import { render, staticRenderFns } from "./struggling-competency-card.vue?vue&type=template&id=96528f56&scoped=true"
import script from "./struggling-competency-card.ts?vue&type=script&lang=ts&external"
export * from "./struggling-competency-card.ts?vue&type=script&lang=ts&external"
import style0 from "./struggling-competency-card.scss?vue&type=style&index=0&id=96528f56&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96528f56",
  null
  
)

export default component.exports